export default "__VITE_ASSET__CRe0SVxP__"